import {
  faAddressCard,
  faCheck,
  faEnvelope,
  faEye,
  faEyeSlash,
  faLock,
  faPhone,
  faUserEdit,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import axios from "../../../api/axios";
import useAuth from "../../../hooks/useAuth";
import InputMask from 'react-input-mask';

const Form = ({refresh}) => {
  const userRef = useRef();
  const errRef = useRef();
  const USER_REGEX = /^[A-z][A-z0-9-_]{3,23}$/;
  const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
  const PHONE_REGEX = /[0-9]$/;

  const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  const REGISTER_URL = "/register/company";
  const { auth } = useAuth();

  const [pwdDisplay, setPwdDisplay] = useState(false);
  const [pwdVDisplay, setPwdVDisplay] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [sucess,setSuccess]=useState('')
  const [valid, setValid] = useState({
    message: [],
    state: true,
  });


  const isValidCUITCUIL=(cuit)=>
	{
    let cuit_nro = cuit.replaceAll("-","");
		let rv = false;
		let resultado = 0;
		const codes = "6789456789";
		let verificador = parseInt(cuit_nro[cuit_nro.length-1]);
		let x = 0;
		
		while (x < 10)
		{
			let digitoValidador = parseInt(codes.substring(x, x+1));
			if (isNaN(digitoValidador)) digitoValidador = 0;
			let digito = parseInt(cuit_nro.substring(x, x+1));
			if (isNaN(digito)) digito = 0;
			let digitoValidacion = digitoValidador * digito;
			resultado += digitoValidacion;
			x++;
		}
		resultado = resultado % 11;
		rv = (resultado == verificador);
		return rv;
	}

  const [values, setValue] = useState({
    businessname: "",
    username: "",
    pwd: "",
    email: "",
    phone: "",
    cuit: "",
    pwdValid: "",
  });
  const defaultValues = {
    businessname: "",
    username: "",
    pwd: "",
    email: "",
    phone: "",
    cuit: "",
    pwdValid: "",
  };

  const handleValue = (e) => {
    setErrMsg([]);
    const newValues = { ...values };

    if (["phone"].includes(e.target.name)) {
      if (PHONE_REGEX.test(e.target.value)) {
        newValues[`${e.target.name}`] = e.target.value;
      }
    } else {
      newValues[`${e.target.name}`] = e.target.value;
    }
    validateValues(newValues);
    setValue({ ...newValues });
  };

  const validateValues = (value) => {
    const defaultValid = {
      message: [],
      state: false,
    };

    const PHONE_REGEX_LENG = /[0-9]{10,11}$/;
    const CUIT_REGEX_LENG = /[0-9]{11,13}$/;

    setValid(defaultValid);
    if (value?.businessname && !USER_REGEX.test(value?.businessname)) {
      defaultValid.state = false;
      defaultValid.message.push(
        "Ingrese un nombre de empresa - largo mínimo 4 letras "
      );
    }
    if (value?.username && !USER_REGEX.test(value?.username)) {
      defaultValid.state = false;
      defaultValid.message.push("Ingrese un usuario - largo mínimo 4 letras");
    }
    if (
      value?.phone &&
      !PHONE_REGEX_LENG.test(value?.phone) &&
      value?.phone.lengh !== 10
    ) {
      defaultValid.state = false;
      defaultValid.message.push(
        "Ingrese un número de teléfono valido por favor - 10 digitos"
      );
    }

    if (value?.email && !EMAIL_REGEX.test(value?.email)) {
      defaultValid.state = false;
      defaultValid.message.push("Ingrese un e-mail valido por favor");
    }

    if (
      value?.cuit && !isValidCUITCUIL(value?.cuit)
    ) {
      defaultValid.state = false;
      defaultValid.message.push(
        "Ingrese un número de cuit valido por favor"
      );
    }

    if (value?.pwd && !PWD_REGEX.test(value?.pwd)) {
      defaultValid.state = false;
      defaultValid.message.push(
        "Ingrese una contraseña valida por favor - debe contener un nro,una mayúscula,\n una minuscula,un carácter especial\n 11 digitos"
      );
    }
    if (value?.pwd && value?.pwd !== value?.pwdValid) {
      defaultValid.state = false;
      defaultValid.message.push(
        "validar que los valores ingresados en ambos campos de contraseña sean idénticos.\n"
      );
    }
    setValid(defaultValid);
    return defaultValid.state;
  };

  useEffect(() => {
    userRef.current.focus();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    const body= {...values,cuit:values.cuit.replaceAll("-","")}
    if (valid.message.length > 0) {
      setErrMsg(valid.message);
      errRef.current.focus();
    } else {
      try {
        const response = await axios.post(
          REGISTER_URL,
          JSON.stringify(body),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: 'Bearer '+auth?.accessToken,
            },
          }
        );
        // TODO: remove console.logs before deployment
        setSuccess(response?.data?.success);
        //console.log(JSON.stringify(response))
        setValue(defaultValues);
        refresh();
      } catch (err) {
        if (!err?.response) {
          setErrMsg(["Servidor no responde"]);
        } else if (err.response?.status === 409) {
          setErrMsg(["Ya existe en base de datos"]);
        } else {
          setErrMsg(["Error al dar el alta"]);
        }
        errRef.current.focus();
      }
    }
  };
  return (
    <div>
      <p className={sucess ? "bg-green text-white text-center" : "offscreen"}>
        {sucess}
      </p>
      <ul
        ref={errRef}
        className={errMsg.length > 0 ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg.map((err, key) => (
          <li key={key}>{err}</li>
        ))}
      </ul>
      <form onSubmit={handleSubmit}>
        <label className="form-label my-4">Empresa</label>

        <div className="col-md-6 order-md-1">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faUserEdit}
              />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Nombre"
              aria-label="nombre"
              ref={userRef}
              autoComplete="off"
              value={values.businessname}
              name="businessname"
              onChange={handleValue}
              required
            />
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faAddressCard}
              />
            </span>
            <InputMask 
              mask='99-99999999-9' 
              type="text"
              className="form-control"
              placeholder="CUIT"
              data-mask="99999999999"
              aria-label="CUIT"
              value={values.cuit}
              autoComplete="off"
              name="cuit"
              onChange={handleValue}
              required
            >
            </InputMask>
          </div>
        </div>
        <label className="form-label my-4 order-md-1">
          Usuario Administrador
        </label>
        <div className="col-md-6 order-md-1">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faUserTie}
              />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Usuario"
              aria-label="usuario"
              name="username"
              value={values.username}
              onChange={handleValue}
              required
            />
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faPhone}
              />
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Teléfono"
              aria-label="Teléfono"
              maxLength="10"
              autoComplete="off"
              name="phone"
              value={values.phone}
              onChange={handleValue}
              required
            />
          </div>
        </div>
        <div className="col-md-6 order-md-1 mb-5">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faEnvelope}
              />
            </span>
            <input
              type="email"
              className="form-control"
              placeholder="E-mail"
              aria-label="E-mail"
              autoComplete="off"
              value={values.email}
              name="email"
              onChange={handleValue}
              required
            />
          </div>
        </div>
        <div className="col-md-6 order-md-1">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faLock}
              />
            </span>
            <input
              type={pwdDisplay ? "text" : "password"}
              className="form-control"
              placeholder="Contraseña"
              aria-label="Contraseña"
              autoComplete="off"
              name="pwd"
              value={values.pwd}
              onChange={handleValue}
              required
            />
            <Button
              variant="outline-secondary"
              id="button-pwdDisplay"
              onClick={(e) => {
                e.preventDefault();
                setPwdDisplay(!pwdDisplay);
              }}
            >
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={pwdDisplay ? faEyeSlash : faEye}
              />
            </Button>
          </div>
        </div>
        <div className="col-md-6 order-md-1">
          <div className="input-group mb-3">
            <span className="input-group-text">
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={faLock}
              />
            </span>
            <input
              type={pwdVDisplay ? "text" : "password"}
              className="form-control"
              placeholder="Confirmar Contraseña"
              aria-label="Contraseña"
              autoComplete="off"
              name="pwdValid"
              value={values.pwdValid}
              onChange={handleValue}
              required
            />
            <Button
              variant="outline-secondary"
              id="button-pwdDisplay"
              onClick={(e) => {
                e.preventDefault();
                setPwdVDisplay(!pwdVDisplay);
              }}
            >
              <FontAwesomeIcon
                style={{ width: "16px", height: "16px" }}
                icon={pwdVDisplay ? faEyeSlash : faEye}
              />
            </Button>
          </div>
        </div>
        <div className="col-md-6 order-md-1">
          <button type="submit" className="btn btn-success mt-4 me-3">
            <FontAwesomeIcon
              style={{ width: "16px", height: "16px" }}
              icon={faCheck}
            />
          </button>
        </div>
      </form>
    </div>
  );
};

export default Form;
